import { useEffect, useState } from "react";
import { ChequeStatusUpdaterObj, ChequeStatusUpdaterProps } from "./types";
import { ChequeStatus } from "../../../types";
import { getAccessForChequeStatus, getNextChequeStatus } from "../../../utils";
import { Button } from "../../buttons";
import { usePopupStore, useThemeStore, useUserStore } from "../../../stores";
import ConfirmChequePopup from "./confirm-cheque-popup";
import { ChequeApi } from "../../../api";
import { QuestionBox } from "../../../popup";
import { useNavigate } from "react-router";

const ChequeStatusUpdater = <T extends {}>({
  cheque,
  status,
  cb,
  back,
}: ChequeStatusUpdaterProps<T>) => {
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const navigate = useNavigate();

  const onConfirm = (): void => {
    setPopupBody(<ConfirmChequePopup back={back} id={cheque._id} cb={cb} />);
  };

  const onDeliver = (): void => {
    setPopupBody(
      <QuestionBox
        question="آیا مطمئن هستید که می خواهید این چک را به مدیر تحویل دهید؟"
        close={false}
        back={back}
        onNo={() => {
          setPopupBody(<back.component {...back.props} />);
        }}
        onYes={() => {
          ChequeApi.deliver(cheque._id.$oid)
            .then((c) => {
              if (cb) cb(c);
            })
            .catch((err) => {
              console.log(err);
              if (cb) cb(null);
            });
        }}
      />
    );
  };

  const onSpend = (): void => {
    navigate(`/financial/spend-factor?number=${cheque.number}`);
    setPopupBody(null);
  };

  const OBJ: ChequeStatusUpdaterObj = {
    received: {
      label: "",
      onClick: () => {},
    },
    confirmed: {
      label: "تایید چک",
      onClick: onConfirm,
    },
    delivered: {
      label: "تحویل به مدیر",
      onClick: onDeliver,
    },
    spent: {
      label: "خرج چک",
      onClick: onSpend,
    },
  };

  const theme = useThemeStore((s) => s.theme);
  const hasUserAccess = useUserStore((s) => s.hasUserAccess);

  const [nStatus, setNStatus] = useState<ChequeStatus | null>(null);

  useEffect(() => {
    setNStatus(getNextChequeStatus(status));
  }, [status]);

  return nStatus && hasUserAccess([getAccessForChequeStatus(nStatus)]) ? (
    <Button
      background={theme.primary}
      color={theme.textOnprimary}
      onClick={OBJ[nStatus].onClick}
    >
      {OBJ[nStatus].label}
    </Button>
  ) : (
    <></>
  );
};

export default ChequeStatusUpdater;
